import React from "react";

export default function SomethingWrong(props) {
    return <div>
        <h3>Oops, something went wrong!</h3>
        <p>If this happens again, please contact <a href="mailto:p.provoost@unesco.org">p.provoost@unesco.org</a>.</p>
        <div className="alert alert-danger">{ props.error }</div>
    </div>
}